/* EVANO guide visual viewport: Safari toolbar and keyboard sizing. */
(() => {
  let viewportFrame = 0;
  const syncGuideViewport = () => {
    viewportFrame = 0;
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    const top = viewport?.offsetTop || 0;
    document.querySelectorAll("[data-evano-size-guide-dialog]").forEach((dialog) => {
      dialog.style.setProperty("--evano-guide-viewport-height", `${height}px`);
      dialog.style.setProperty("--evano-guide-viewport-top", `${top}px`);
    });
  };
  const scheduleGuideViewport = () => {
    if (!viewportFrame) viewportFrame = window.requestAnimationFrame(syncGuideViewport);
  };
  window.visualViewport?.addEventListener("resize", scheduleGuideViewport);
  window.visualViewport?.addEventListener("scroll", scheduleGuideViewport);
  window.addEventListener("resize", scheduleGuideViewport);
  document.addEventListener("click", scheduleGuideViewport, true);
  syncGuideViewport();
})();

/* EVANO shared visual guide enhancement: PDP dialog + linked size-guide page. */
(() => {
  const visualFromTemplate = () => {
    const template = document.querySelector('[data-evano-size-guide-visual-template]');
    return template?.content.querySelector('[data-evano-size-guide-visual]')?.cloneNode(true) || null;
  };

  const updateMeasurementCopy = (root) => {
    if (!root) return;
    const candidates = [...root.querySelectorAll('p')];
    const waist = candidates.find((node) => /cintura/i.test(node.textContent || ''));
    const hip = candidates.find((node) => /cadera/i.test(node.textContent || ''));

    if (waist) {
      const strong = waist.querySelector('strong');
      waist.replaceChildren();
      if (strong) waist.append(strong);
      else {
        const label = document.createElement('strong');
        label.textContent = 'Cintura:';
        waist.append(label);
      }
      waist.append(document.createTextNode(' mide el contorno a la altura del ombligo, sin apretar.'));
    }

    if (hip) {
      const strong = hip.querySelector('strong');
      hip.replaceChildren();
      if (strong) hip.append(strong);
      else {
        const label = document.createElement('strong');
        label.textContent = 'Cadera:';
        hip.append(label);
      }
      hip.append(document.createTextNode(' mide el contorno en la zona más ancha, con los pies juntos.'));
    }
  };

  const enhanceProductDialogs = () => {
    document.querySelectorAll('[data-evano-size-guide-dialog]').forEach((dialog) => {
      const content = dialog.querySelector('.evano-size-guide-dialog__content');
      if (!content || content.dataset.evanoVisualReady === 'true') return;

      const visual = visualFromTemplate();
      const measurements = content.querySelector('.evano-size-guide-dialog__measurements');
      if (!visual || !measurements) return;

      updateMeasurementCopy(measurements);
      content.append(visual);
      content.classList.add('evano-size-guide-dialog__content--visual');
      content.dataset.evanoVisualReady = 'true';
    });
  };

  const enhanceLinkedPage = () => {
    const page = document.querySelector('body.evano-size-guide-page .t4s-main-page');
    const source = page?.querySelector('[data-evano-size-guide-page-visual-source]');
    const content = source?.nextElementSibling;
    const visual = source?.querySelector('[data-evano-size-guide-visual]');
    if (!page || !source || !content || !visual || content.dataset.evanoVisualReady === 'true') return;

    const children = [...content.children];
    const eyebrow = children.find((node) => node.tagName === 'P' && /encuentra tu talla/i.test(node.textContent || ''));
    const intro = children.find((node) => node.tagName === 'P' && /mide tu cuerpo/i.test(node.textContent || ''));
    const measurements = children.find((node) => node.tagName === 'DIV' && !node.querySelector('table') && /cintura/i.test(node.textContent || '') && /cadera/i.test(node.textContent || ''));
    const table = children.find((node) => node.querySelector?.('table'));
    const note = children.find((node) => node.tagName === 'P' && /horma|elasticidad/i.test(node.textContent || ''));
    const help = children.find((node) => node.tagName === 'DIV' && node.querySelector('a[href*="wa.me"]'));

    if (!measurements || !table) return;

    updateMeasurementCopy(measurements);
    eyebrow?.setAttribute('data-evano-size-guide-eyebrow', '');
    intro?.setAttribute('data-evano-size-guide-intro', '');
    measurements.setAttribute('data-evano-size-guide-measurements', '');
    table.setAttribute('data-evano-size-guide-table', '');
    note?.setAttribute('data-evano-size-guide-note', '');
    help?.setAttribute('data-evano-size-guide-help', '');
    measurements.before(visual);
    source.remove();
    content.dataset.evanoVisualReady = 'true';
  };

  enhanceLinkedPage();
  enhanceProductDialogs();

  const guideMutationSelector = '[data-evano-size-guide-dialog], [data-evano-size-guide-visual-template]';
  const observer = new MutationObserver((records) => {
    const relevant = records.some((record) => {
      if (record.target.nodeType === 1 && record.target.closest(guideMutationSelector)) return true;
      return [...record.addedNodes].some((node) => node.nodeType === 1 &&
        (node.matches(guideMutationSelector) || node.querySelector(guideMutationSelector)));
    });
    if (relevant) enhanceProductDialogs();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();
